import { useCallback } from 'react';

import cfg from '../gridConstans';
import { TPadding, TRect } from '../type';

const { SVG, GRAPH } = cfg;
const { PADDING, INNER_PADDING } = GRAPH;

// return TRect and utils to work with graph part of the graph
export default function useCoordinates(
  domNode: HTMLElement | null,
  px: number,
  maxWeeks: number,
  maxCount: number
) {
  const padding: TPadding = {
    top: px * PADDING.TOP,
    left: px * PADDING.LEFT,
    right: px * PADDING.RIGHT,
    bottom: px * PADDING.BOTTOM,
  };

  const width = SVG.WIDTH - padding.left - padding.right;
  const aspectRatio = domNode
    ? domNode.offsetWidth / domNode.offsetHeight
    : cfg.SVG.DEFAULT_ASPECT_RATIO;
  const svgHeight = SVG.WIDTH / aspectRatio;

  const height = svgHeight - padding.top - padding.bottom;
  const innerPadding = height * INNER_PADDING;

  const x = useCallback(
    (v: number) => padding.left + v / (maxWeeks / (width - innerPadding)),
    [px, maxWeeks]
  );

  const y = useCallback(
    (v: number) =>
      padding.top + height - v / (maxCount / (height - innerPadding)),
    [px, maxCount]
  );

  const xy = useCallback(
    (xx: number, yy: number): string => `${x(xx)},${y(yy)}`,
    [x, y]
  );

  const graphRect: TRect = {
    left: padding.left,
    right: padding.left + width,
    width,
    height,
    top: padding.top,
    bottom: padding.top + height,
  };

  return {
    x,
    y,
    xy,
    graphRect,
    svgHeight,
  };
}
